import React, { Fragment, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

import { PageSection } from '@ui/components/PageSection'
import { Tab } from '@ui/components/Tabs'

type HeaderActions = {
  allowMarkAllRead: boolean
  onMarkAllRead: () => void
}

export const NotificationsPage: React.FC = () => {
  const { t } = useTranslation()

  const [headerActions, setHeaderActions] = useState<HeaderActions>({
    allowMarkAllRead: false,
    onMarkAllRead: () => {},
  })

  const tabs: Tab[] = useMemo(
    () => [
      { label: t('Notifications.tabs.All'), path: 'all' },
      { label: t('Notifications.tabs.General'), path: 'general' },
      { label: t('Notifications.tabs.Platform'), path: 'platform' },
      { label: t('Notifications.tabs.Promotional'), path: 'promotional' },
    ],
    [t]
  )

  return (
    <Fragment>
      <PageSection
        renderActions={[
          {
            disabled: !headerActions.allowMarkAllRead,
            onClick: headerActions.onMarkAllRead,
            title: t('Notifications.Mark All Read'),
          },
        ]}
        title={t('Notifications.Notifications')}
        tabData={{
          tabs,
        }}
      />
      <Outlet context={{ setHeaderActions }} />
    </Fragment>
  )
}
